export const flowEvent = 'route-flow-event'
export const cleanFlowEvent = 'clean-route-flow-event'

export const availableFlows = ['search']
